export default __webpack_public_path__ + "static/media/LOGO.bd47613d.png";